/* ==================== REWARDS – spillogik oven på ads.js =====================
   Hvornår MÅ et "se en video → få X"-tilbud vises, og hvad sker der når
   spilleren tager imod det. Boderne spørger offerAvailable() før de tegner
   tilbudsknappen (tilbyd aldrig en video, der ikke kan leveres) og kalder
   claimReward() ved klik.

   Regler (roadmap 1.5):
   - Max 3 rewarded ads pr. session (konservativ start).
   - Cooldown pr. tilbud, så samme tilbud ikke spammes.
   - Pokal-værn håndhæves i boderne: ekstra skud/kugler må aldrig kunne
     udløse guldpokal (klomaskinen giver kun små tøjdyr — ingen konflikt).
================================================================================ */

import { adsAvailable, showRewardedAd } from "./ads.js";

const MAX_PER_SESSION = 3;
const OFFER_COOLDOWN_MS = 90 * 1000; // samme tilbud tidligst hvert 1½ minut

let sessionCount = 0;
const lastShown = {}; // offer-name -> timestamp for sidst gennemførte visning

export function offerAvailable(name) {
  if (!adsAvailable()) return false;
  if (sessionCount >= MAX_PER_SESSION) return false;
  const last = lastShown[name] || 0;
  return Date.now() - last >= OFFER_COOLDOWN_MS;
}

/** Vis annoncen og giv belønningen (kun ved fuldt set video). */
export function claimReward(name, { onReward, onNoReward }) {
  if (!offerAvailable(name)) { onNoReward && onNoReward("unavailable"); return; }
  showRewardedAd({
    name,
    onReward: () => {
      sessionCount += 1;
      lastShown[name] = Date.now();
      onReward && onReward();
    },
    onNoReward,
  });
}
